export default {
  id: "4ffc9733-51f4-4bbc-bc33-54fd56446468",
  icon: "mdi-message-question",
  name: "contentMultipleChoiceQuestionTemplate",
  title: "Template Multiple Choice Question",
  description: "A multiple Choice template block",
};
